import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import LogInForm from '@/shared/components/account/loginForm/LogInForm';
import {
  AccountCard,
  AccountContent,
  AccountHead,
  AccountLogo,
  AccountLogoAccent,
  AccountTitle,
  AccountWrap,
} from '@/shared/components/account/AccountElements';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { GlobalContext } from '../../../context/GlobalContext';
import SignupAgentForm from '../../../shared/components/account/NewAgent/SignupAgent';
 
 

 
const SignupAgent = () => {
    const { apiGlobal } = useContext(GlobalContext);
     const [checkedTandC, setCheckedTandC] = useState(false);
     const [loading, setLoading] = useState(false);
    const history = useHistory();

    const handleSubmit = async (formValues) => {
        // console.log(JSON.stringify(formValues, null, 2));
         if (!formValues.country) {
            toast.error('Please select country');
            return;
         }
         if (!formValues.countryCode) {
            toast.error('Please select country code');
            return;
         }

        const formData = new FormData();
        formData.append('agentName', formValues.agentName);
        formData.append('user_email', formValues.email);
        formData.append('user_phone', formValues.phone_no);
        formData.append('country_code', formValues.countryCode?.value);
        formData.append('uan', formValues.uan);
        formData.append('addressLine1', formValues.addressline1);
        formData.append('addressLine2', formValues.addressline2);
        formData.append('area', formValues.area);
        formData.append('city', formValues.city);
        formData.append('state', formValues.state);
        formData.append('country', formValues.country?.value);
        formData.append('pincode', formValues.pincode);
        formData.append('locationOnMap', formValues.location);
        formData.append('logo', formValues.file);
        formData.append('gst_no', formValues.gst_no);
        formData.append('gst_type', formValues.gst_type);
        formData.append('gst_proof_file', formValues.gst_proof);
        formData.append('address_proof_file', formValues.address_proof);
        formData.append('defaultMarkup', formValues.markup);
        formData.append('taxId', formValues.taxId);
        formData.append('taxCity', formValues.taxCity);
        formData.append('type', '1');
        formData.append('tc', checkedTandC ? '1' : '0');

    
      //   Array.from(formData.entries()).forEach(([key, value]) => {
      //     // If the value is a file, we need to log file details, not just the file object
      //     if (value instanceof File) {
      //         console.log(key, value.name); // Log file name
      //     } else {
      //         console.log(key, value); // Log other values
      //     }
      // });
          setLoading(true);
        try {
          const response = await fetch(`${apiGlobal}/agent_add.php`, {
            method: 'POST',
            body: formData,
          });
    
          const data = await response.json();
    
          if (data.status) {
            toast.success('Agent added successfully!');
            setCheckedTandC(false);
            history.push('/');
          } else {
            toast.error(data.message);
          }
        } catch (error) {
          alert(`An Error Occurred: ${error.message}`);
          console.error('Submit Error:', error);
        } finally {
          setLoading(false);
        }
      };


  return (
    <div>
      <SignupAgentForm 
        form="/signup"
        onSubmit={handleSubmit}
        checkedTandC={checkedTandC}
        setCheckedTandC={setCheckedTandC}
        loading={loading}
      />
      {/* <AccountOr>
          <p>Or Easily Using</p>
        </AccountOr> */}
      {/* Add other social login buttons as needed */}
         
      {/* </AccountCard> */}
    </div> 
             
        
    
    );
};
 
// LogIn.propTypes = {
//   changeIsOpenModalFireBase: PropTypes.func.isRequired,
// };
 
export default SignupAgent;
 
